import { Component } from '@angular/core';
import { RulesGame } from '../../../shared/components/rules/rules-game/rules-game';
import { SelectLanguage } from '../../../shared/components/language/select-language/select-language';
import { UserProfile } from '../../../shared/components/profile/user-profile/user-profile';
import { ExitGame } from '../../../shared/components/buttons/exit-game/exit-game';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-heder-game',
  imports: [RulesGame, SelectLanguage, UserProfile, ExitGame],
  templateUrl: './heder-game.html',
  styleUrl: './heder-game.scss'
})
export class HederGame {
  public settings = environment;

}
